<template>

  <div v-if="ready" class="dataList colorList">
    
    <div id="colorSliderElement">
        <div v-if="backgroundHasColor(item)" class="item hover-fade smooth pointer" v-for="item in colors" v-on:click="pickItem(item)">
        	<div 
        	v-bind:style="{ background: item.preview, border: item.border }"
        	v-bind:class="{ color: true }">
           <i v-if="currentColor.key == item.key" class="fa fa-check"></i> 
          </div> 
        </div> <!-- item -->
    </div> <!-- #articleSliderElement-->

  </div>
</template>

<script>
export default {
  data: function(){
    return{
      colors: false,
      ready: false
    } 
  },
 
  props: ['backgroundData'],

  computed: { 

    currentColor(){
      return this.$store.state.pictureWallColor;
    }

  },

  methods: {

    getColors: function(){

      var self = this;

      // API returns the data after ajax loading
      window.apiHandler['colors'](function(data){

        // Set data
        self.$set(self, 'colors', data);

        // Set ready
        self.ready = true;

      });

    },

    init: function(){

      // Initialize slider
      require('../../../build/modules/slider.js')
        
      var sliderElement = $("#colorSliderElement");
      
      sliderElement.slick({
        infinite: false,
        dots: false,
        slidesToShow: 11,
         responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
            }
          }
        ]
      })

    },

    pickItem: function(item){
    	this.$store.commit('pictureWallColor', item); 
    },

    backgroundHasColor: function(color){
        if(typeof this.backgroundData.colors[color.key] != 'undefined')
          return true;

        return false;
    }

  },

  mounted: function () { 
    this.getColors();
  }

}
</script>

<style>
.colorList{

    text-align: center;

    .slick-slide{
      border: 0px;
    } 

    .item{
      padding: 0px 4px !important;
      margin-top: 6px;
    }

     /* Mobile */
    @media screen and (max-width: 812px) {
      .item{
          padding: 5px 3px 0px 3px !important;
      }
    }

    .color{
    	width: 26px;
      height: 26px;
      position: relative;

      i{
          color: #e8e8e8;
          position: absolute;
          text-align: center;
          width: 100%;
          left: 0;
          top: 50%;
          margin-top: -7px;
      }

      &.active{
        border: 4px #ececec solid
      }

      /* Mobile */
      @media screen and (max-width: 812px) {
        width: 20px;
        height: 20px;
      }

    } 

} 
</style>



// WEBPACK FOOTER //
// ColorList.vue?e4fd253e